import * as types from './actionTypes';

export function offersSet(offersList: any) {
  return { type: types.OFFERS_SET, offersList };
}
